import React from 'react';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import Pusher from 'pusher-js';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';

import {
  PageWrapper,
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { PUSHER_APP_KEY } from 'api/constants';
import { askConfirmAction } from 'actions/confirm-action';
import {
  pageRequest,
  handleSuccessAsyncJob,
  handleFailedAsyncJob,
  submitAssignToItem,
  setDeletedCategory,
  hideDeleteModal,
  deleteCategory,
} from 'actions/businessLibrary/category';
import ConfirmActionModal from 'components/ConfirmActionModal';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import List from './List';
import ActionBar from './ActionBar';
import CategoryDetail from './CategoryDetail';
import AssignToItemModal from './AssignToItemModal';

class Category extends React.Component {
  componentDidMount() {
    const { businessId } = this.props;
    browserHistory.listenBefore(this.routerWillLeave);
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(`moka-${businessId}`);
    this.props.dispatch(pageRequest());
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  componentDidUpdate() {
    const { dispatch, eventAsyncJob } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    if (eventAsyncJob.channelName !== null) {
      this.channel.bind(eventAsyncJob.channelName, data => {
        if (data.job_id && data.success) {
          dispatch(handleSuccessAsyncJob(data.resource_id));
        } else if (data.job_id && !data.success) {
          dispatch(handleFailedAsyncJob(data.error));
        }
      });
    }
  }

  render() {
    const {
      showLoadingSpinnerPage,
      categories,
      openRightColumn,
      showDeleteModal,
      deletedCategory,
    } = this.props;
    const categoryName = deletedCategory ? deletedCategory.name : '';
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={categories.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Categories"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454606-Cara-Membuat-Kategori-Item"
            />
            {categories.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <CategoryDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <AssignToItemModal onSubmit={this._onSubmit} />
        <ConfirmActionModal />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title="Category"
          name={categoryName}
          onDelete={this._onDelete}
        />
      </PageWrapper>
    );
  }

  _onSubmit = values => {
    const { items } = this.props;
    const itemName = [];

    values.business_level_item_ids.forEach(id => {
      items.forEach(item => {
        if (`${id}` === `${item.id}`) {
          itemName.push(item.name);
        }
      });
    });
    this.props.dispatch(
      submitAssignToItem(
        { business_level_item_ids: values.business_level_item_ids },
        values.id
      )
    );
  };

  _onHideModal = () => {
    const { dispatch } = this.props;
    dispatch(setDeletedCategory(null));
    dispatch(hideDeleteModal());
  };

  _onDelete = () => {
    const { dispatch, categories, deletedCategory } = this.props;
    dispatch(deleteCategory(deletedCategory.id, categories));
  };

  routerWillLeave = location => {
    const { isDirtyCategory } = this.props;
    if (isDirtyCategory && !this.props.nextAction) {
      this.props.dispatch(askConfirmAction(push(location)));
      return false;
    }
  };
}

function mapStateToProps(state) {
  const isDirtyCategory = isDirty('categoryHub')(state);
  const { nextAction } = state.confirmAction;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const {
    categories,
    openRightColumn,
    assignToItems: { items },
    deletedCategory,
    showDeleteModal,
    eventAsyncJob,
  } = state.businessLibrary.categoryHub;
  return {
    categories,
    deletedCategory,
    eventAsyncJob,
    items,
    openRightColumn,
    isDirtyCategory,
    nextAction,
    showLoadingSpinnerPage,
    showDeleteModal,
    businessId: state.moka.user.business.id,
  };
}

export default connect(mapStateToProps)(Category);
